import { Card } from "@/components/ui/card";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

interface ExpenseTrackerProps {
  title: string;
  data: Array<{ category: string; amount: number }>;
}

export const ExpenseTracker = ({ title, data }: ExpenseTrackerProps) => {
  return (
    <Card className="p-5 shadow-sm">
      <div className="mb-2">
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
      </div>
      <ResponsiveContainer width="100%" height={140}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" opacity={0.3} />
          <XAxis
            dataKey="category"
            stroke="var(--muted-foreground)"
            fontSize={12}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            stroke="var(--muted-foreground)"
            fontSize={12}
            tickLine={false}
            axisLine={false}
            tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}k`}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "var(--popover)",
              border: "1px solid var(--border)",
              borderRadius: "8px",
            }}
            formatter={(value: number) => [`₹${value.toLocaleString("en-IN")}`, "Amount"]}
          />
          <Bar dataKey="amount" fill="var(--chart-1)" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
